import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import PreferencesApiUtils from '../utils/PreferencesApiUtils';
import { CHANGE_EVENT } from '../constants/AppConstants';
import {
  STANDARD,
  SET_MODE,
  SET_PREFERENCE_UPDATE_STATUS,
  REQUEST_UPDATE_PREFERENCES,
  REQUEST_UPDATE_PREFERENCES_SUCCESS,
  REQUEST_UPDATE_PREFERENCES_ERROR,
  SET_PREFERENCES,
} from '../constants/PreferencesConstants';

class PreferencesStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
    this.state = {
      preferences: {},
      updating: false,
      updated: false,
      error: false,
      mode: STANDARD,
    };
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getPreferences() {
    return this.state.preferences;
  }

  getUIState() {
    return {
      updating: this.state.updating,
      updated: this.state.updated,
      error: this.state.error,
    };
  }

  getMode() {
    return this.state.mode;
  }
  getUpdateStatus() {
    return this.state.updated;
  }
  getIsGroupApprovalsEnabled() {
    return (
      this.state.preferences.group_approvals &&
      this.state.preferences.group_approvals.enabled === 'true'
    );
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    switch (actionType) {
      case SET_MODE:
        this.state.mode = data.action.data;
        this.emitChange();
        break;
      case SET_PREFERENCE_UPDATE_STATUS:
        this.state.updated = data.action.data;
        this.emitChange();
        break;
      case REQUEST_UPDATE_PREFERENCES:
        this.state.updating = true;
        this.emitChange();
        PreferencesApiUtils.updatePreferences(data.action.data);
        break;
      case REQUEST_UPDATE_PREFERENCES_SUCCESS:
        this.state.updated = true;
        this.state.updating = false;
        this.emitChange();
        break;
      case REQUEST_UPDATE_PREFERENCES_ERROR:
        this.state.updated = false;
        this.state.updating = false;
        this.state.error = true;
        this.emitChange();
        break;
      case SET_PREFERENCES:
        this.state.preferences = data.action.data;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new PreferencesStore();
